<box class="fpx-field-content">
    <div class="camera-view" #cameraView>
        <box *ngIf="IMAGE_DATA">
            <img [src]="IMAGE_DATA" alt="document" />
        </box>
    </div>
</box>